import ClienteDetalhe from './ClienteDetalhe';

export default ClienteDetalhe;